import PropTypes from "prop-types"
import React from "react"

const ReservationBadges = ({ reservation }) => {
  const badges = []

  // Space Type Badge
  if (reservation.requestedSpaceType) {
    const isDoc = reservation.requestedSpaceType.toLowerCase() === "dock"
    badges.push(
      <span
        key="space-type"
        className={`label label-inline-block ${
          isDoc ? "badge-orange" : "badge-bg-blue"
        }`}
      >
        {reservation.requestedSpaceType.charAt(0).toUpperCase() +
          reservation.requestedSpaceType.slice(1)}
      </span>
    )
  }

  // Wide Beam Badge
  if (reservation.wideBeam) {
    badges.push(
      <span key="wide-beam" className="label label-inline-block label-warning">
        Wide Beam
      </span>
    )
  }

  // Special Request Badge
  if (reservation.specialRequest) {
    badges.push(
      <span
        key="special-request"
        className="label label-inline-block label-success"
      >
        Special Request
      </span>
    )
  }

  // Check-in Status Badges
  if (reservation.checkedInNotOut) {
    badges.push(
      <span
        key="checked-in"
        className="label label-inline-block badge-blue-inverted"
      >
        Checked In
      </span>
    )
  }

  if (reservation.checkedOut) {
    badges.push(
      <span key="checked-out" className="label label-inline-block badge-gray">
        Checked Out
      </span>
    )
  }

  // Payment Status Badges
  if (reservation.unpaidNotPending) {
    badges.push(
      <span key="unpaid" className="label label-inline-block label-danger">
        Unpaid
      </span>
    )
  } else if (reservation.addCardLater) {
    badges.push(
      <span
        key="missing-card"
        className="label label-inline-block label-warning"
      >
        Missing Card
      </span>
    )
  }

  // Communication Badge
  if (reservation.unreadBoaterMessages) {
    badges.push(
      <span
        key="unread-message"
        className="label label-inline-block label-danger"
      >
        Unread Message
      </span>
    )
  }

  // Manual Approval Badge
  if (reservation.contactRequiresManualApproval) {
    badges.push(
      <span
        key="manual-approval"
        className="label label-inline-block label-dark"
      >
        See Customer Note
      </span>
    )
  }

  return (
    <div
      className="flex flex-wrap items-center justify-start gap-1.5 py-2"
      style={{ fontSize: "1.1em" }}
    >
      {badges}
    </div>
  )
}

ReservationBadges.propTypes = {
  reservation: PropTypes.shape({
    belongsToContract: PropTypes.bool,
    contractGroupName: PropTypes.string,
    requestedSpaceType: PropTypes.string,
    wideBeam: PropTypes.bool,
    specialRequest: PropTypes.bool,
    checkedInNotOut: PropTypes.bool,
    checkedOut: PropTypes.bool,
    unpaidNotPending: PropTypes.bool,
    addCardLater: PropTypes.bool,
    unreadBoaterMessages: PropTypes.bool,
    contactRequiresManualApproval: PropTypes.bool,
  }).isRequired,
}

export default ReservationBadges
